<template>
  <tr
    class="i-listview-node"
    :class="{'i-state-select': isInspected}"
    role="listitem"
  >
    <td @click="() => inspectDocument(item)"
      v-for="{name, width, maxWidth} in activeColumns"
      :key="name"
      class="i-listview-body-column"
      :class="`col__${name}`"
      >
        <component
          v-if="fieldComponent(name)"
          :is="fieldComponent(name)"
          :item="item"
          :column="name"
          :expanded="expanded"
          :selected="selected"
          :style="{ maxWidth: (maxWidth || width) ? `${maxWidth || width}px` : 'auto' }"
          v-bind="$attrs"
        />
        <div v-else
          class="i-cell-value"
          :style="{ maxWidth: (maxWidth || width) ? `${maxWidth || width}px` : 'auto' }"
        >
          <label :title="item[name]">
            {{item[name] || (name === 'title' ? 'No title' : '')}}
          </label>
        </div>
    </td>
    <td key="spacer"></td>
  </tr>
</template>

<script>
import { defineComponent } from 'vue';
import { mapBrowserState, mapBrowserGetters, mapBrowserMutations } from '@/store';
import DocumentFieldIcon from '@/components/browser/documents/DocumentFieldIcon.vue';
import DocumentFieldActionsButton from '@/components/browser/documents/DocumentFieldActions.vue';
import DocumentFieldSelectionCheckbox from '@/components/browser/documents/DocumentFieldSelect.vue';
import DocumentFieldUpToDateStatus from '@/components/browser/documents/DocumentFieldUpToDate.vue';
import DocumentFieldUrl from '@/components/browser/documents/DocumentFieldUrl.vue';
import DocumentFieldRowExpander from '@/components/browser/documents/DocumentFieldExpand.vue';
import DocumentFieldReferences from '@/components/browser/documents/DocumentFieldReferences.vue';
import DocumentFieldLiveUri from '@/components/browser/documents/DocumentFieldLiveUri.vue';
import DocumentFieldFileSize from '@/components/browser/documents/DocumentFieldFileSize.vue';
import DocumentFieldDate from '@/components/browser/documents/DocumentFieldDate.vue';

const FieldComponents = {
  preview_url: DocumentFieldIcon,
  actions: DocumentFieldActionsButton,
  select: DocumentFieldSelectionCheckbox,
  is_up_to_date: DocumentFieldUpToDateStatus,
  url: DocumentFieldUrl,
  expand: DocumentFieldRowExpander,
  references: DocumentFieldReferences,
  filesize: DocumentFieldFileSize,
  live_url: DocumentFieldLiveUri,
  created_at: DocumentFieldDate,
  finished_at: DocumentFieldDate,
  publish_date: DocumentFieldDate,
  published_at: DocumentFieldDate,
  expiry_date: DocumentFieldDate,
  resubmit_date: DocumentFieldDate,
};

export default defineComponent({
  inheritAttrs: false,
  props: {
    item: Object,
    expanded: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    viewport: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapBrowserState(['inspectedDocument']),
    ...mapBrowserGetters(['activeColumns']),
    isInspected() {
      return this.inspectedDocument && ['node_id', 'uri_id', 'master'].every((key) => this.item[key] === this.inspectedDocument[key]);
    },
  },
  methods: {
    ...mapBrowserMutations(['inspectDocument']),
    fieldComponent(name) {
      return FieldComponents[name];
    },
  },
});
</script>
